import React from "react";

const searchBox = ({search}) => {
    return (
        <div className="pa2">
        <input
        className="pa3 ba b--green bg-lightest-blue" 
        type="search" 
        placeholder="search robot"
        onChange={search} />
        </div>
    );
}

export default searchBox;